import { render, staticRenderFns } from "./HeathSafetyBudgetExecutionRateChart.vue?vue&type=template&id=8f4c08d4&scoped=true"
import script from "./HeathSafetyBudgetExecutionRateChart.vue?vue&type=script&lang=js"
export * from "./HeathSafetyBudgetExecutionRateChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4c08d4",
  null
  
)

export default component.exports